// TermsOfService.js
import React from 'react';
import {
  ChakraProvider,
  Box,
  Heading,
  Text,
  VStack,
  Button,
  Link,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ArrowBackIcon } from '@chakra-ui/icons';

const TermsOfService = () => {
  return (
    <ChakraProvider>
      <Box
        display={'flex'}
        w={['95%', null, null, null, '50%']}
        mr={['2.5%', null, null, null, '25%']}
        alignItems={'center'}
        justifyContent={'flex-start'}
      >
        <Link as={ReactRouterLink} to={'/'}>
          <Button
            color={'#242424'}
            alignSelf={'flex-end'}
            aria-label="Inicio"
            leftIcon={<ArrowBackIcon />}
            bgColor={'transparent'}
          >
            Volver
          </Button>
        </Link>
      </Box>
      <Box w={['90%', null, null, null, '50%']} mx="auto" mt="4" pb="8">
        <Heading mb="4">Condiciones de Uso de RouteForecast.app</Heading>
        <Text fontSize="sm" color="gray.600" mb="6">
          Última actualización: 28 de enero de 2026
        </Text>

        <VStack align="start" spacing="6">
          <Text>
            <strong>1. Aceptación de las Condiciones</strong>
            <br />
            Al acceder y utilizar RouteForecast.app (en adelante, "el
            Servicio"), aceptas estar vinculado por estas Condiciones de Uso. Si
            no estás de acuerdo con alguna parte de estas condiciones, no debes
            utilizar el Servicio.
          </Text>

          <Text>
            <strong>2. Descripción del Servicio</strong>
            <br />
            RouteForecast.app proporciona información meteorológica para rutas
            terrestres basándose en datos de la Agencia Estatal de Meteorología
            (AEMET) y otras fuentes. El Servicio es una herramienta informativa
            y de planificación.
          </Text>

          <Box>
            <Text fontWeight="bold" mb="2">
              3. Descargo de Responsabilidad sobre la Información Meteorológica
            </Text>
            <Text>
              <strong>3.1. Exactitud de la Información:</strong>
              <br />
              La información meteorológica proporcionada es de carácter
              informativo y se basa en datos de terceros (principalmente AEMET).
              Aunque nos esforzamos por proporcionar información precisa y
              actualizada:
            </Text>
            <UnorderedList ml="6" mt="2" spacing="1">
              <ListItem>
                NO GARANTIZAMOS la exactitud, completitud o actualidad de los
                datos
              </ListItem>
              <ListItem>
                Los pronósticos pueden cambiar sin previo aviso
              </ListItem>
              <ListItem>
                Pueden existir errores técnicos o retrasos en la actualización
              </ListItem>
              <ListItem>
                La información puede no reflejar condiciones locales específicas
              </ListItem>
            </UnorderedList>
            <Text mt="3">
              <strong>3.2. Uso Bajo Tu Propio Riesgo:</strong>
              <br />
              El uso de la información proporcionada es BAJO TU EXCLUSIVA
              RESPONSABILIDAD. Antes de tomar decisiones basadas en nuestros
              pronósticos:
            </Text>
            <UnorderedList ml="6" mt="2" spacing="1">
              <ListItem>
                Consulta fuentes oficiales adicionales (AEMET, DGT, etc.)
              </ListItem>
              <ListItem>
                Verifica las condiciones meteorológicas actuales
              </ListItem>
              <ListItem>
                Toma precauciones adicionales en condiciones adversas
              </ListItem>
              <ListItem>
                Considera tu experiencia y capacidades personales
              </ListItem>
            </UnorderedList>
            <Text mt="3">
              <strong>3.3. Limitación de Responsabilidad:</strong>
              <br />
              EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY, RouteForecast.app, sus
              creadores, colaboradores y afiliados NO SERÁN RESPONSABLES de:
            </Text>
            <UnorderedList ml="6" mt="2" spacing="1">
              <ListItem>Daños personales, lesiones o pérdida de vidas</ListItem>
              <ListItem>Daños materiales a vehículos o propiedades</ListItem>
              <ListItem>Pérdidas económicas directas o indirectas</ListItem>
              <ListItem>Retrasos, cancelaciones o cambios de planes</ListItem>
              <ListItem>
                Decisiones tomadas basándose en la información proporcionada
              </ListItem>
              <ListItem>
                Errores u omisiones en los datos meteorológicos
              </ListItem>
              <ListItem>Interrupciones del servicio o fallos técnicos</ListItem>
            </UnorderedList>
          </Box>

          <Text>
            <strong>4. Fuentes de Datos</strong>
            <br />
            Los datos meteorológicos provienen principalmente de:
            <br />
            - Agencia Estatal de Meteorología (AEMET)
            <br />
            - Otras fuentes meteorológicas públicas
            <br />
            <br />
            No somos responsables de la exactitud de los datos proporcionados
            por estas fuentes. Para información oficial y alertas
            meteorológicas, consulta directamente{' '}
            <a
              href="https://www.aemet.es"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.aemet.es
            </a>
            .
          </Text>

          <Text>
            <strong>5. Uso Apropiado del Servicio</strong>
            <br />
            Al utilizar el Servicio, te comprometes a:
            <br />
            - NO utilizarlo como única fuente para decisiones críticas de
            seguridad
            <br />
            - NO sobrecargar el sistema con solicitudes automatizadas excesivas
            <br />
            - NO intentar acceder a áreas restringidas o datos no públicos
            <br />
            - NO redistribuir o revender la información sin autorización
            <br />- Cumplir con todas las leyes aplicables
          </Text>

          <Text>
            <strong>6. Propiedad Intelectual</strong>
            <br />
            <strong>6.1. Contenido del Sitio:</strong> El diseño, código,
            gráficos y presentación de RouteForecast.app están protegidos por
            derechos de autor y otras leyes de propiedad intelectual.
            <br />
            <br />
            <strong>6.2. Datos Meteorológicos:</strong> Los datos de AEMET están
            sujetos a sus propias condiciones de uso. Consulta{' '}
            <a
              href="https://www.aemet.es/es/nota_legal"
              target="_blank"
              rel="noopener noreferrer"
            >
              las condiciones de AEMET
            </a>
            .
            <br />
            <br />
            <strong>6.3. Marcas Comerciales:</strong> Todas las marcas
            mencionadas son propiedad de sus respectivos dueños.
          </Text>

          <Text>
            <strong>7. Disponibilidad del Servicio</strong>
            <br />
            El Servicio se proporciona "TAL CUAL" y "SEGÚN DISPONIBILIDAD":
            <br />
            - No garantizamos disponibilidad ininterrumpida
            <br />
            - Podemos suspender o modificar el servicio sin previo aviso
            <br />
            - Podemos discontinuar el servicio en cualquier momento
            <br />- No somos responsables de interrupciones técnicas
          </Text>

          <Text>
            <strong>8. Publicidad</strong>
            <br />
            El Servicio muestra publicidad de terceros (Google AdSense) para
            financiar su operación. Al utilizar el sitio:
            <br />
            - Aceptas la visualización de publicidad
            <br />
            - Entiendes que no controlamos el contenido de los anuncios de
            terceros
            <br />- Cualquier interacción con anunciantes es bajo tu propia
            responsabilidad
          </Text>

          <Text>
            <strong>9. Enlaces a Terceros</strong>
            <br />
            El Servicio puede contener enlaces a sitios web de terceros. No
            somos responsables del contenido, políticas o prácticas de estos
            sitios. El acceso a enlaces externos es bajo tu propio riesgo.
          </Text>

          <Text>
            <strong>10. Modificaciones de las Condiciones</strong>
            <br />
            Nos reservamos el derecho de modificar estas Condiciones en
            cualquier momento. Los cambios significativos se notificarán
            mediante aviso en el sitio web. El uso continuado del Servicio tras
            la publicación de cambios constituye aceptación de las nuevas
            condiciones.
          </Text>

          <Text>
            <strong>11. Indemnización</strong>
            <br />
            Aceptas indemnizar y mantener indemne a RouteForecast.app, sus
            creadores y colaboradores de cualquier reclamación, pérdida,
            responsabilidad, daño o gasto (incluyendo honorarios legales)
            derivados de:
            <br />
            - Tu uso del Servicio
            <br />
            - Tu violación de estas Condiciones
            <br />- Tu violación de derechos de terceros
          </Text>

          <Text>
            <strong>12. Ley Aplicable y Jurisdicción</strong>
            <br />
            Estas Condiciones se rigen por las leyes de España. Cualquier
            disputa se resolverá en los tribunales de España, renunciando
            expresamente a cualquier otro fuero que pudiera corresponder.
          </Text>

          <Text>
            <strong>13. Divisibilidad</strong>
            <br />
            Si alguna disposición de estas Condiciones se considera inválida o
            inaplicable, el resto de las disposiciones permanecerán en pleno
            vigor.
          </Text>

          <Text>
            <strong>14. Contacto</strong>
            <br />
            Para preguntas sobre estas Condiciones de Uso:
            <br />
            <strong>Responsable:</strong> Pablo Osés Andía
            <br />
            <strong>Domicilio:</strong> Calle Rosario Romero 8 1B, 28029 Madrid,
            España
            <br />
            <strong>Email:</strong>{' '}
            <a href="mailto:pablo98oses@gmail.com">pablo98oses@gmail.com</a>
          </Text>
        </VStack>

        <Box
          mt="8"
          p="4"
          bg="red.50"
          borderRadius="md"
          borderLeft="4px solid"
          borderColor="red.500"
        >
          <Text fontWeight="bold" mb="2">
            ⚠️ AVISO IMPORTANTE DE SEGURIDAD
          </Text>
          <Text fontSize="sm">
            RouteForecast.app es una herramienta informativa, NO un sistema de
            seguridad vial o meteorológica. SIEMPRE consulta fuentes oficiales
            (AEMET, DGT) y utiliza tu propio juicio antes de viajar. En caso de
            condiciones adversas, prioriza tu seguridad sobre cualquier
            pronóstico.
          </Text>
        </Box>

        <Box mt="4" p="4" bg="gray.50" borderRadius="md">
          <Text fontSize="sm">
            Al utilizar RouteForecast.app, confirmas que has leído, entendido y
            aceptado estas Condiciones de Uso y nuestra{' '}
            <Link
              as={ReactRouterLink}
              to="/privacidad"
              color="blue.500"
              textDecoration="underline"
            >
              Política de Privacidad
            </Link>
            .
          </Text>
        </Box>
      </Box>
    </ChakraProvider>
  );
};

export default TermsOfService;
